//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import BaseIcon from '~/components/BaseIcon.vue';
import makeClasses from '~/helpers/makeClasses';
import formatDate from '~/helpers/formatDate';

const VIEWS = {
    vertical: 'vertical',
    horizontal: 'horizontal'
};

const useClasses = makeClasses(() => ({
    reviewsButton: ({ view, disableReview }) => ({
        'transition-fast relative': true,
        'hover:opacity-60': !disableReview,
        'pointer-events-none': disableReview,
        'mb-3': view === VIEWS.vertical
    }),
    reviewsContainer: () => 'flex items-center -mx-0.5 whitespace-nowrap',
    star: () => ({
        'mx-0.5 fill-current': true
    })
}));


export default {
    components: { BaseIcon },
    props: {
        page: { type: Object, required: true }
    },
    computed: {
        createdAt() {
            return this.page ? formatDate(this.page.createdAt, 'D MMM YYYY') : null;
        },
        classes() {
            return useClasses({
                view: VIEWS.vertical
            });
        }
    }
};
